import React from 'react';

function Footer(){
    return (
        <footer>
            <p>Keep in Touch! Contact me through my email, phone number or linkedin! </p>
            <p>Email: <a href="g807b153@gmail.com">g807b153@gmail.com</a></p>
            <p>Phone Number: 913-547-4517</p>
            <p><a 
                href="/Resume-website-10-9-25.pdf" 
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: "inline-block",
                    padding: "10px 20px",
                    backgroundColor: "#007BFF", // Blue button background
                    color: "white", // White text
                    textDecoration: "none", // Remove underline
                    borderRadius: "5px", // Rounded corners
                    fontWeight: "bold", // Bold text
                    fontSize: "16px",
                  }} >Resume</a></p>
        </footer>
    );
}

export default Footer;